import React from 'react';

export const getRandomColor = () => {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const generateCoords = (xcoords, ycoords) => {
  const xcoordsArr = xcoords.split('|').map(Number);
  const ycoordsArr = ycoords.split('|').map(Number);
  const xycoordsArr = [];
  xcoordsArr.map((xcoord, index) => {
    xycoordsArr.push(xcoord);
    xycoordsArr.push(ycoordsArr[index]);
    return xcoord;
  });
  return xycoordsArr;
};

export const card = () => (
  <div class="card">
                           <img src="img_avatar.png" alt="Avatar" style={{ width: '100%' }} />
    <div class="container">
      <h4>
        <b>John Doe</b>
      </h4>
      <p>Architect and Engineer</p>
    </div>
  </div>
);

export const generateRectCoords = (x, y, w, h) => {
  return [x, y, x + w, y + h];
};
